export default __webpack_public_path__ + "static/media/icon-contacts-phone.8fcdaf62.svg";